export default "__VITE_ASSET__BT_nW8Os__ 640w, __VITE_ASSET__Yc$k4q2u__ 1024w";